import * as modelDefinitions from './modelDefinitions'
// full_TEST overrides WIP
import * as productModelDefinitions from './modelDefinitions/full_TEST'
import QuickFiltersMixin from '@/common/quickFilters'

export default {
  computed: {
    modelsSetup() {
      let models = {}
      for (const fileName of Object.keys(modelDefinitions)) {
        // Multiple Models per file support
        for (const modelInFile of Object.keys(modelDefinitions[fileName].computed)) {
          models[modelInFile] = this[modelInFile]
        }
      }
      return models
    }
  },
  mixins: [...Object.values(modelDefinitions), QuickFiltersMixin],
  mounted() {
    console.log('full_TEST overrides WIP >>>', modelDefinitions, productModelDefinitions)
    this.setModels()
    this.$root.$on('reloadModels', () => this.setModels())
  },
  methods: {
    setModels() {
      console.log(this.modelsSetup)
      this.$store.dispatch('setModels', this.modelsSetup)
    }
  }
}
